import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'library/util/core-router';
import { array } from 'prop-types';
import Confirm from 'library/helpers/confirm';
import destroyDeterminerMutation from 'apps/admin/pages/persona-determiners/queries/destroy-determiner-mutation';
import withReloadParent from 'util/hoc/with-reload-parent';
import Notification, { Error as NotificationError, Success } from 'library/components/notification';
import { resolve } from 'library/helpers/path-resolver';

import 'library/helpers/array';

const StyledTable = styled.table`
  text-align: left;
  margin: 1em;
  tbody {
    tr {
      height: 2em;
      &:nth-child(odd) {
        background: #efefef;
      }
    }
  }
`;

const InputHolder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 10%;
  div {
    label {
      text-align: center;
      input {
        margin: 0 1em;
      }
    }
    button {
      height: 40px;
      width: 100%;
    }
  }
`;

const mapOptions = (option) => option.map((option, i) => (
  <option name={option} key={i}>
    {option}
  </option>
));

const StyledList = styled.ul`
  text-align: left;
`;

const DeterminerTable = ({determiners, reloadParentGraph}) => {
  const [selected, setSelected] = useState([]);

  const selectedDeteminers = () => (
    determiners.filter(({id}) => selected.indexOf(id) !== -1)
  );

  const addSelected = (e, id) => {
    if(e.target.checked) {
      setSelected(selected => [...selected, id]);
    } else {
      setSelected(selected => [...selected.deleteValue(id)]);
    }
  };

  const handleDestroy = async (id) => {
    if(await Confirm('Are you sure?')) {
      try {
        const success = await destroyDeterminerMutation(id);
        if(success) {
          Notification.new(
            {timeout: 5000},
            <Success>
              The determiner has been successfully deleted.
            </Success>
          );
          reloadParentGraph();
        }
      }
      catch (e) {
        console.error(e);
      }
    }
  };

  const mapDeterminers = () => {
    const stuff = determiners.map((determiner, i) => (
      <tr key={i}>
        <td><input type="checkbox" onClick={(e) => addSelected(e, determiner.id)} value={determiner.id}/></td>
        <td>
          <Link to={`/admin/persona-determiners/${determiner.id}`}>
            {determiner.id}
          </Link>
        </td>
        <td>{determiner.title}</td>
        <td>{resolve(determiner, 'persona/name', '-- no persona provided --')}</td>
        <td><a href='javascript:void(0)' onClick={() => handleDestroy(determiner.id)}>Delete</a></td>
      </tr>
    ));
    return stuff;
  };

  return (
    <StyledTable>
      <thead>
        <tr>
          <th></th>
          <th>ID</th>
          <th>Title</th>
          <th>Persona</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {determiners && mapDeterminers()}
      </tbody>
    </StyledTable>
  );
};

DeterminerTable.propTypes = {
  determiners: array
};

export default withReloadParent(DeterminerTable);
